var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBroadbandInternetOutlined = function SvgHtlBroadbandInternetOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htlBroadbandInternetOutlined_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v15.995h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htlBroadbandInternetOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.69 14A1.889 1.889 0 0 1 2 11.964v-.929A1.888 1.888 0 0 1 3.69 9H11V4.5a.5.5 0 0 1 1 0V9h.311A1.888 1.888 0 0 1 14 11.035v.929A1.889 1.889 0 0 1 12.31 14H3.69ZM3 11.035v.929c0 .562.317 1.036.69 1.036h8.62c.375 0 .69-.474.69-1.036v-.929c0-.562-.316-1.035-.689-1.035H3.69c-.374 0-.69.471-.69 1.032v.003Zm1.116-3.383A5.464 5.464 0 0 1 3.5 4.963a5.474 5.474 0 0 1 .615-2.69.5.5 0 0 1 .887.46 4.475 4.475 0 0 0-.5 2.212v.036c-.026.768.146 1.53.5 2.211a.5.5 0 1 1-.888.457v.003Zm1.947-.6a4.069 4.069 0 0 1-.508-2.089c-.021-.73.154-1.45.508-2.089a.5.5 0 1 1 .879.479 3.067 3.067 0 0 0-.384 1.627 3.067 3.067 0 0 0 .384 1.589.5.5 0 1 1-.88.48v.003Zm1.982-.514A2.757 2.757 0 0 1 7.6 4.964a2.758 2.758 0 0 1 .443-1.575.5.5 0 0 1 .841.54 1.755 1.755 0 0 0-.283 1.017v.037c-.011.36.088.714.285 1.015a.5.5 0 1 1-.842.537v.003Z"
  }))));
};
export default SvgHtlBroadbandInternetOutlined;